<template>
  <div>
    <h-loading v-if="hostLoading" />

    <div v-if="!hostLoading && Object.keys(data).length">
      <HostStatus :data="data" />
      <HostBasicInfo :data="data" />
      <HostServices :data="data" />
      <HostAsaasAccount v-if="data.asaas_account" :data="data" />
      <HostFiles v-if="data.id" :host-id="data.id" />
    </div>

    <v-row v-if="!hostLoading && !Object.keys(data).length">
      <v-col>
        <EmptyState />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HostStatus from './summaryComponents/HostStatus'
import HostBasicInfo from './summaryComponents/HostBasicInfo'
import HostAsaasAccount from './summaryComponents/HostAsaasAccount'
import HostServices from './summaryComponents/HostServices'
import HostFiles from './summaryComponents/HostFiles'
import EmptyState from '@/components/app/EmptyState'

export default {
  name: 'HostSummary',

  props: {
    data: {
      type: Object,
      default: {},
    },
  },

  components: {
    HostStatus,
    HostBasicInfo,
    HostAsaasAccount,
    HostServices,
    HostFiles,
    EmptyState,
  },

  computed: {
    ...mapGetters(['hostLoading']),
  },
}
</script>
